import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import Loader from '../../common/Loader';
import DealDetailCard from './components/DetailCard';
import DealOverview from './components/Overview/Details';
import DealActions from './redux/actions';
// import { Tabs } from 'antd';
import { InvestorStatus, dealStatus, dealTypes } from '../../login/utils/Status';
import DataRoom from './components/DataRoom/DataRoom';
import IssuerInfo from './components/IssuerInfo/IssuerInfo';
import Webinars from './components/Webinar/Webinar';
// import ContactUs from './components/ContactUs/ContactUs';
import moment from 'moment';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import alertIcon from '../../../assets/images/alertIcon.svg';
import TabsComponent from '../../common/Tabs';
import { PDFStateData } from '../PDFView/PDFView';
import ContactUsNew from '../dealList/components/ContactUsNew';
import { common_container } from '../dealList/components/deals/TopCard';
import UserAlret from '../userAlret';
import CashflowSimulator from './components/CashflowSimulator';
import HIPLDetails from './components/HIPL';
import KeyDocuments from './components/KeyDocuments';
import Teaser from './components/Teaser';
import FundDealModel from './modal/FundDeal';
import { showDetailCards } from './utils';

const DealDetailsTab = {
    summary: 'summary',
    issuer_info: 'issuer_info',
    data_room: 'data_room',
};

const DealDetails: React.FC = () => {
    let uuid = useParams().uuid;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const stateData: PDFStateData = location.state as PDFStateData;

    const deal = useSelector((state: RootState) => state.deal.deal);
    const termSheetData = useSelector((state: RootState) => state.deal.termSheetData);
    const loader = useSelector((state: RootState) => state.deal.loading);
    const disclosure = useSelector((state: RootState) => state.deal.disclosure);
    const webinarLoading = useSelector((state: RootState) => state.deal.webinarLoading);

    const [activeTab, setActiveTab] = useState('summary');

    //Calling Deal detail API
    useLayoutEffect(() => {
        if (uuid) {
            dispatch(DealActions.getDealDetailReq(uuid, navigate));
            dispatch(DealActions.fetchTeaserDoc(uuid));
        }
    }, [uuid, dispatch, navigate]);

    useEffect(() => {
        function handleHashScroll() {
            if (!loader && !webinarLoading && window.location.hash) {
                const id = window.location.hash.replace('#', '');
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }

        // Scroll on mount if hash exists and loader is done
        handleHashScroll();

        // Listen for hash changes
        window.addEventListener('hashchange', handleHashScroll);

        return () => {
            window.removeEventListener('hashchange', handleHashScroll);
        };
    }, [loader, webinarLoading]);

    //After click back from PDF redirect to data room
    useEffect(() => {
        if (stateData && !loader) {
            setActiveTab(DealDetailsTab.data_room);
            const dealTabView = document.getElementById('deal_details_data_room');
            if (dealTabView) {
                const top = dealTabView.offsetTop + (window.innerWidth > 900 ? 400 : 600);
                window.scrollTo({ top: top });
            }
        }
    }, [stateData, loader]);

    //Calling Data Room and Webinar API if status not completed
    useLayoutEffect(() => {
        if (deal && deal.deal.status !== dealStatus.completed && uuid) {
            dispatch(DealActions.getDealDataRoomReq(uuid));
            dispatch(DealActions.getDealWebinarReq(uuid));
        }
        if (deal?.deal.info?.summary?.dealType === dealTypes.fund) {
        }
    }, [uuid, dispatch, deal]);

    //This function we used for check mobile or desktop view
    // useEffect(() => {
    //     if (window.innerWidth < 700) {
    //         setIsVertical(true);
    //     }
    //     if (restart) {
    //         setRestart(false);
    //     }

    //     function handleResize() {
    //         setIsVertical(window.innerWidth < 700 ? true : false);
    //     }
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, [restart]);

    const component = useMemo(() => {
        switch (activeTab) {
            case DealDetailsTab.summary:
                return <DealOverview deal={deal?.deal} />;
            case DealDetailsTab.issuer_info:
                return <IssuerInfo issuer={deal?.issuer} />;
            case DealDetailsTab.data_room:
                return <DataRoom />;
            default:
                return null;
        }
    }, [activeTab, deal]);

    const dealTabs = useMemo(() => {
        let Tabs = [
            { title: 'Summary', key: DealDetailsTab.summary },
            { title: 'Issuer Info', key: DealDetailsTab.issuer_info },
            { title: 'Data Room', key: DealDetailsTab.data_room },
        ];

        if (
            deal?.investorStatus &&
            deal?.investorStatus?.profile &&
            deal?.investorStatus?.profile.replace(/ +/g, '') !== InvestorStatus.Approved
        ) {
            Tabs.splice(1, 1);
        }

        return Tabs;
    }, [deal]);

    return (
        <>
            {uuid && <FundDealModel open={disclosure} UUID={uuid} />}
            {!loader && (
                <>
                    <DealDetailCard deal={deal} termSheetData={termSheetData || ''} />

                    <div className={common_container}>
                        {deal?.deal.status && !disclosure && showDetailCards(deal?.deal.status) && (
                            <>
                                <div className="flex flex-col md:flex-row justify-between gap-2 items-baseline mb-6">
                                    <div className="flex items-center w-full  md:w-[60%] p-4 bg-[#FFFFF] border border-solid border-[#27AE60] shadow-card shadow-[#0000001A] mt-6">
                                        <img src={alertIcon} alt="alert" />

                                        <div className="pl-4">
                                            <p className="font-[WorkSans-Bold] text-[#0F2240] uppercase text-lg font-bold">
                                                {'Expression of interest'}
                                            </p>
                                            <p className="font-normal md:text-[13px] text-xs font-[Lato] pt-0.5 text-[#20222B]">
                                                Please raise your interest using the buttons above or email us at&nbsp;
                                                <a
                                                    href="mailto:sales@heli-cap.com"
                                                    className="text-[#27AE60]"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    sales@heli-cap.com
                                                </a>{' '}
                                                {deal.deal.info.summary?.endTime ? (
                                                    <>
                                                        by&nbsp;
                                                        {moment(deal.deal.info.summary?.endTime).format('DD/MM/YYYY')}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    {/* <div className="md:block hidden w-[3%]"></div>
                                    <div className="md:w-[37%]  w-full">
                                        <UserAlret
                                            text_div_className="block"
                                            align={'justify-start'}
                                            isDealAllow={true}
                                        />
                                    </div> */}
                                </div>
                                <div className="flex flex-wrap">
                                    <div className="w-full sm:w-full md:w-[60%] flex flex-col items-start">
                                        <div className="rounded-md overflow-hidden h-auto w-full relative">
                                            <TabsComponent
                                                tabs={dealTabs}
                                                activeTab={activeTab}
                                                setActiveTab={setActiveTab}
                                            />

                                            <div className="mb-6">{component}</div>
                                        </div>
                                        {activeTab === DealDetailsTab.summary &&
                                            deal.deal.info?.summary?.dealType === dealTypes.fund && (
                                                <div className=" overflow-hidden  bg-white w-full relative">
                                                    <HIPLDetails />
                                                </div>
                                            )}
                                    </div>
                                    <div className="md:block hidden w-[5%]"></div>
                                    <div className="w-full sm:w-full md:w-[35%] flex flex-col gap-4 mb-4">
                                        <Teaser />
                                        <Webinars />

                                        {deal.deal.cashFlowSimulator?.repaymentType &&
                                            deal.deal.cashFlowSimulator?.showInInvestorPortal && (
                                                <div className="md:ml-4 ">
                                                    <CashflowSimulator />
                                                </div>
                                            )}

                                        <UserAlret
                                            text_div_className="block"
                                            align={'justify-start'}
                                            isDealAllow={true}
                                            parentDivClassName={'md:ml-4'}
                                        />

                                        <KeyDocuments />

                                        <div className="md:ml-4">
                                            <ContactUsNew isMobile isShowTitle={false} />
                                        </div>

                                        {/* <ContactUs deal={deal?.deal} /> */}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}
            {loader && (
                <div className="flex justify-center items-center my-10">
                    <Loader />
                </div>
            )}
        </>
    );
};

export default DealDetails;
